exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-a6483a8e] {\n  font-size: 11px;\n}\n.fa-stack[data-v-a6483a8e] {\n  font-size: 11px;\n}\n.fa-backward[data-v-a6483a8e]::before {\n  margin-left: -5px;\n}\n", ""]);

// exports
